import { render, staticRenderFns } from "./UnitDropdown.vue?vue&type=template&id=2c882630&"
import script from "./UnitDropdown.vue?vue&type=script&lang=js&"
export * from "./UnitDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports